import $ from 'jquery';

export default function footerSection() {
	const $footerNotes = $('.footer-notes');
  
  /** for any of the listed classed, set the footer context to white */
	const defaultClasses = ['.homepage', '.destinations', '.about', '.contact', '.accommodation', '.experiences', '.booking', 'search', '.landingPage', '.journey', '.walk'];
	const joined = $(defaultClasses.join(','));
	const generalPage = $('.generalPage');

	if (joined.length) $footerNotes.addClass('\+background-white');

	if (generalPage.length) {

		const $body = generalPage.find('.body');
		const $lastBodySection = $body.find('.body_section:last-child');

		if (!$lastBodySection.hasClass('\+background-white')) {
			$footerNotes.addClass('\+background-white');
		}
	}
}


// WEBPACK FOOTER //
// ./source/scripts/sections/footer.js